<router-outlet></router-outlet>

<p-toast position="bottom-center" key="public-toast-error" styleClass="px-4">
    <ng-template let-message #headless>
            <div class="flex items-center p-3">
                <i class="pi pi-times-circle mr-2 !text-xl"></i> {{ message.detail }}
            </div>
    </ng-template>
</p-toast>
<p-toast position="bottom-center" key="public-toast-success" styleClass="px-4">
    <ng-template let-message #headless>
            <div class="flex items-center p-3">
                <i class="pi pi-check-circle mr-2 !text-xl"></i> {{ message.detail }}
            </div>
    </ng-template>
</p-toast>